const i = {
  position: "relative",
  p: 0,
  bg: "lightGray3",
  color: "white",
  cursor: "pointer",
  border: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  transition: "all",
  ":focus-visible": (e) => ({
    ...e.outline()
  }),
  ":hover": {
    opacity: 0.8
  },
  ":active": {
    opacity: 1
  },
  '&[data-state="checked"]': {
    bg: "primary"
  },
  ":disabled": {
    cursor: "default",
    pointerEvents: "none",
    bg: "stroke",
    color: "secondaryText"
  }
}, o = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, s = {
  sm: {
    size: 5,
    borderRadius: "xs",
    ":focus-visible::after": {
      borderRadius: "sm"
    }
  },
  md: {
    size: (e) => e.spacing(5.5),
    borderRadius: "xs",
    ":focus-visible::after": {
      borderRadius: "sm"
    }
  },
  lg: {
    size: (e) => e.spacing(7.5),
    borderRadius: "sm",
    ":focus-visible::after": {
      borderRadius: "md"
    }
  }
}, t = {
  checkboxSizes: s
};
export {
  o as checkboxIndicator,
  i as checkboxStyles,
  t as checkboxesTheme
};
